import React from 'react';
import {
    AutocompleteArrayInput, ChipField, Datagrid, DateField, Edit, EmailField, List, ReferenceArrayField,
    ReferenceArrayInput, ShowGuesser, SimpleForm, SingleFieldList, TextField, TextInput
} from 'react-admin';

// Users as the backend returns them: { id, email, user: { timeJoined, thirdParty }, metadata, roles: [role ids] }.
const UserList: React.FC = () => (
    <List perPage={50}>
        <Datagrid rowClick="edit">
            <TextField label="First Name" source="metadata.first_name" />
            <TextField label="Last Name" source="metadata.last_name" />
            <EmailField source="email" />
            <ReferenceArrayField label="Roles" reference="roles" source="roles" sortable={false}>
                <SingleFieldList>
                    <ChipField source="name" size="small" />
                </SingleFieldList>
            </ReferenceArrayField>
            <DateField label="Time Joined" source="user.timeJoined" />
            <TextField label="Provider" source="user.thirdParty.id" />
        </Datagrid>
    </List>
);

const UserEdit: React.FC = () => (
    <Edit mutationMode="pessimistic">
        <SimpleForm>
            <TextInput source="email" disabled />
            <TextInput label="Full Name" source="metadata.full_name" />
            <TextInput label="First Name" source="metadata.first_name" />
            <TextInput label="Last Name" source="metadata.last_name" />
            <ReferenceArrayInput reference="roles" source="roles" perPage={100}>
                <AutocompleteArrayInput label="Roles" optionText="name" sx={{ minWidth: 400 }} />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const users = {
    list: UserList,
    edit: UserEdit,
    show: ShowGuesser
};
